export enum TruckDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP'
}
